<svg>
  <use attr.xlink:href="{{src | woFileHash}}"/>
</svg>
